<script lang="ts">
  import {
    type MarqyDirection,
    calcReps,
    calcAnimationDuration,
    createResizeObserver,
  } from '../core'
  import type { Snippet } from 'svelte'

  interface Props {
    speed?: number
    direction?: MarqyDirection
    pauseOnHover?: boolean
    manual?: boolean
    children: Snippet
    [key: string]: unknown
  }

  let {
    speed = 0.5,
    direction = 'left' as MarqyDirection,
    pauseOnHover = false,
    manual = false,
    children,
    ...rest
  }: Props = $props()

  let containerDims = $state({ width: 0, height: 0 })
  let itemDims = $state({ width: 0, height: 0 })

  let reps = $derived.by(() => {
    const cSize = isVertical ? containerDims.height : containerDims.width
    const iSize = isVertical ? itemDims.height : itemDims.width
    return calcReps(cSize, iSize)
  })

  const isVertical = $derived(direction === 'up' || direction === 'down')

  const animationDuration = $derived(
    calcAnimationDuration(
      isVertical ? itemDims.height : itemDims.width,
      reps,
      speed
    )
  )
</script>

<div
  {@attach (containerEl) => {
    return createResizeObserver(containerEl, (d) => {
      containerDims = d
    })
  }}
  data-marqy=""
  data-direction={direction}
  data-pause-on-hover={pauseOnHover ? '' : undefined}
  {...rest}
>
  <div data-marqy-inner="">
    {#each [0, 1] as clone}
      <div
        data-marqy-content=""
        {...manual
          ? { 'data-marqy-static': animationDuration }
          : { style: `animation-duration: ${animationDuration}` }}
      >
        {#each Array.from({ length: reps }, (_, i) => i) as rep}
          <div
            {@attach clone === 0 && rep === 0
              ? undefined
              : (node) => {
                  return createResizeObserver(node, (d) => {
                    itemDims = d
                  })
                }}
            aria-hidden={!(clone === 0 && rep === 0) || undefined}
            data-marqy-item=""
          >
            {@render children()}
          </div>
        {/each}
      </div>
    {/each}
  </div>
</div>
